﻿<script>
  import { ModalBody, ModalFooter, ModalHeader, Modal } from "sveltestrap";
  import backend from "../../../../../../server";
  import { createEventDispatcher } from "svelte";
  import alertify from 'alertifyjs';
  import 'alertifyjs/build/css/alertify.css'
  import Dropdown from "../../../../ui/Dropdown.svelte";
  import InfoTooltip from "../../../../ui/InfoTooltip.svelte";
  import RemotePlayerSelect from "../../player/RemotePlayerSelect.svelte";
  import {
    FREE_SPINS_BONUS_TYPES,
    buildBetScaleIndex,
    buildGamesPayload,
    buildPragmaticBetScalesQuery,
    getBetScaleOptions,
    reconcileBetConfigurationValue,
    reconcileGameConfigurations,
    updateBetConfiguration,
    validateGameConfigurations,
    validateGamesPayload
  } from "../../../../../utils/pragmaticGames.js";
  import {
    buildPragmaticFreeSpinRequest,
    generatePragmaticBonusCode,
    validatePragmaticFreeSpinFields,
  } from "../../../../../utils/pragmaticFreeSpin.js";
  import { getPragmaticDemoPlayers } from "../../../../../config/demoClient.js";

  const dispatch = createEventDispatcher(); // Crear un dispatcher para emitir eventos
  const FRB_TYPES = FREE_SPINS_BONUS_TYPES;
  const FREE_BONUS_FEATURE = "FREE_BONUS_FEATURE";
  const CAMPAIGN_BET_TYPE_OPTIONS = [
    { value: "totalBet", description: "Apuesta total" },
  ];
  export let showNewFreeSpin;
  export let clients;

  let players = [];
  let gameConfigurations = [];
  let availableGamesFRB=[];
  let selectedGame=[];
  let selectedPlayerId = "";
  let selectedClientId = "";
  let selectedClientCode = "";
  const defaultLimaDateTime = (days = 0) =>
    new Date(Date.now() + days * 86400000 - 5 * 60 * 60 * 1000).toISOString().slice(0, 16);
  let pragmaticCreateFRB = {
    currency: "",
    expirationDate: "",
  };
  let searchQuery = '';
  let filteredGamesList = [];
  const parseLimaDateTime = (value) => {
    const normalized = String(value ?? "").trim();
    return normalized ? new Date(`${normalized}:00-05:00`) : null;
  };
  let campaignStartDate = defaultLimaDateTime();
  let betScaleIndex = new Map();
  let betScalesLoading = false;
  let betScalesError = false;
  let campaignBetType = "totalBet";
  let requestedGameIdsKey = null;
  let betScalesRequestSequence = 0;
  let gamesLoading = false;
  let gamesError = "";
  let gamesRequestSequence = 0;
  let clientCurrencies = [];
  let currenciesLoading = false;
  let currenciesError = "";
  let currencyClientId = null;
  const ASSIGNATION_MODE = [
          //{value: "AUTO", label: "Automática"},
          {value: "MANUAL", label: "Manual"}
  ];

  function normalizeCurrency(value) {
    return String(value ?? "").trim().toUpperCase();
  }

  function supportsFreeSpinType(game, freeSpinType) {
    if (freeSpinType !== "F") return true;
    return Array.isArray(game?.features) && game.features.includes(FREE_BONUS_FEATURE);
  }

  function removeIncompatibleGames() {
    const incompatibleIds = new Set(
      incompatibleSelectedGames.map((game) => String(game.gameID ?? game.gameId)),
    );
    selectedGame = selectedGame.filter((gameId) => !incompatibleIds.has(String(gameId)));
  }

  function setFreeSpinType(value) {
    if (value === "F" && selectedGame.length > 1) {
      selectedGame = [];
      alertify.warning("Se retiraron los juegos seleccionados porque Full Scatter admite solamente uno.");
    }
    pragmaticCreateFRB = { ...pragmaticCreateFRB, frType: value };
  }

  function setSingleGame(value) {
    selectedGame = value === null || value === undefined || value === "" ? [] : [value];
  }

  function configurationsWithCurrency(configurations, currency) {
    return configurations.map((game) => ({
      ...game,
      betValues: game.betValues.map((row) => ({
        ...row,
        currency,
        value:
          normalizeCurrency(row.currency) === currency
            ? row.value
            : "",
      })),
    }));
  }

  function applyCampaignCurrency() {
    gameConfigurations = configurationsWithCurrency(
      gameConfigurations,
      normalizeCurrency(pragmaticCreateFRB.currency),
    );
  }

  function setCampaignCurrency(value) {
    const currency = normalizeCurrency(value);
    pragmaticCreateFRB = { ...pragmaticCreateFRB, currency };
    applyCampaignCurrency();
    reconcileAllBetValues();
  }

  function setClientCurrency(client) {
    selectedPlayerId = "";
    players = [];
    betScaleIndex = new Map();
    const currency = normalizeCurrency(client?.currency);
    clientCurrencies = currency ? [currency] : [];
    currenciesLoading = false;
    currenciesError = client && !currency ? "El cliente no tiene una moneda configurada" : "";
    pragmaticCreateFRB = { ...pragmaticCreateFRB, currency };
    applyCampaignCurrency();
  }

  async function loadClientGames(clientCode, currency) {
    const requestSequence = ++gamesRequestSequence;
    selectedGame = [];
    gameConfigurations = [];
    availableGamesFRB = [];
    gamesError = "";
    if (!clientCode || !currency) {
      gamesLoading = false;
      return;
    }
    gamesLoading = true;
    try {
      const response = await backend.games.listPragmaticFrbGames(clientCode, currency);
      if (requestSequence !== gamesRequestSequence) return;
      availableGamesFRB = Array.isArray(response?.data?.gameList)
        ? response.data.gameList
        : [];
      if (!availableGamesFRB.length) gamesError = "El cliente no tiene juegos disponibles";
    } catch (error) {
      if (requestSequence !== gamesRequestSequence) return;
      gamesError = "No se pudieron cargar los juegos del cliente";
      console.error("Error cargando los juegos de Pragmatic:", error);
    } finally {
      if (requestSequence === gamesRequestSequence) gamesLoading = false;
    }
  }

  async function listPragmaticPlayers(params) {
    if (!clientCurrencies.length) return { data: { list: [], total: 0 } };
    const responses = await Promise.all(
      clientCurrencies.map((currency) =>
        backend.users.list({ ...params, currency }),
      ),
    );
    const playersById = new Map();
    let total = 0;
    for (const response of responses) {
      const payload = response?.data ?? response;
      total += Number(payload?.total ?? 0);
      for (const player of Array.isArray(payload?.list) ? payload.list : []) {
        if (player?.id !== null && player?.id !== undefined) {
          playersById.set(String(player.id), player);
        }
      }
    }
    return { data: { list: [...playersById.values()], total } };
  }

  const onShowModalFreeSpin = ()=> (showNewFreeSpin = !showNewFreeSpin);

  async function getBetScales(gameIds) {
    const requestSequence = ++betScalesRequestSequence;
    if (gameIds.length === 0) {
      betScaleIndex = new Map();
      betScalesLoading = false;
      betScalesError = false;
      reconcileAllBetValues();
      return;
    }
    betScalesLoading = true;
    betScalesError = false;
    
    try {
      const request = { clientCode: selectedClientCode, gameIDs: gameIds.join(","), currencies: clientCurrencies.join(",") };
      const params = buildPragmaticBetScalesQuery(request);
      const response = await backend.freespin.getBetScalesPrg(params);
      if (requestSequence !== betScalesRequestSequence) return;
      const payload = response?.data ?? response;
      if (String(payload?.error ?? "0") !== "0") throw new Error(payload?.description || "Bet scales request failed");
      betScaleIndex = buildBetScaleIndex(payload);
    } catch (error) {
      if (requestSequence !== betScalesRequestSequence) return;
      betScaleIndex = new Map();
      betScalesError = true;
      console.error("Error al obtener las escalas de apuesta:", error);
    } finally {
      if (requestSequence === betScalesRequestSequence) {
        betScalesLoading = false;
        reconcileAllBetValues();
      }
    }
  }


  function synchronizeSelectedGames(selectedIds, games) {
    gameConfigurations = configurationsWithCurrency(
      reconcileGameConfigurations(
        selectedIds,
        gameConfigurations,
        games,
        campaignBetType,
      ),
      normalizeCurrency(pragmaticCreateFRB.currency),
    );
  }

  function updateBetValue(gameId, rowIndex, field, value) {
    gameConfigurations = updateBetConfiguration(gameConfigurations, gameId, rowIndex, field, value);
    if (field === "betType") {
      const row = gameConfigurations.find((game) => game.gameId === gameId)?.betValues[rowIndex];
      const options = getBetScaleOptions(betScaleIndex, gameId, row?.currency, row?.betType);
      gameConfigurations = updateBetConfiguration(gameConfigurations, gameId, rowIndex, "value", reconcileBetConfigurationValue(row?.value, options));
    }
  }

  function updateCampaignBetType(value) {
    campaignBetType = value;
    gameConfigurations = gameConfigurations.map((game) => ({
      ...game,
      betValues: game.betValues.map((row) => ({
        ...row,
        betType: campaignBetType,
        value: reconcileBetConfigurationValue(
          row.value,
          getBetScaleOptions(betScaleIndex, game.gameId, row.currency, campaignBetType)
        )
      }))
    }));
  }

  function reconcileAllBetValues() {
    gameConfigurations = gameConfigurations.map((game) => ({
      ...game,
      betValues: game.betValues.map((row) => ({
        ...row,
        value: reconcileBetConfigurationValue(row.value, getBetScaleOptions(betScaleIndex, game.gameId, row.currency, row.betType))
      }))
    }));
  }

  function betScaleOptions(gameId, row) {
    return getBetScaleOptions(betScaleIndex, gameId, row.currency, row.betType);
  }

  function betScaleDropdownOptions(gameId, row) {
    return betScaleOptions(gameId, row).map((scale) => ({ value: scale, description: String(scale) }));
  }

  function betScalePlaceholder(gameId, row) {
    if (betScalesLoading) return "Cargando...";
    if (betScalesError) return "No disponible";
    return betScaleOptions(gameId, row).length === 0 ? "No disponible" : "Seleccionar...";
  }

  $: filteredGamesList = availableGamesFRB.filter((game) =>
    supportsFreeSpinType(game, pragmaticCreateFRB.frType),
  );
  $: incompatibleSelectedGames = pragmaticCreateFRB.frType === "F"
    ? availableGamesFRB.filter((game) =>
        selectedGame.map(String).includes(String(game.gameID ?? game.gameId)) &&
        !supportsFreeSpinType(game, pragmaticCreateFRB.frType),
      )
    : [];
  $: synchronizeSelectedGames(selectedGame, availableGamesFRB);
  $: selectedClientCode =
    clients.find(
      (item) => String(item.id) === String(selectedClientId)
    )?.code ?? "";
  $: if (selectedClientId !== currencyClientId) {
    currencyClientId = selectedClientId;
    const client = clients.find((item) => String(item.id) === String(selectedClientId));
    setClientCurrency(client);
    loadClientGames(
      client?.code ?? client?.clientCode ?? "",
      normalizeCurrency(client?.currency),
    );
  }
  $: selectedGameIdsKey = [...new Set(selectedGame.map(String))].sort().join(",");
  $: betScalesRequestKey = [
    selectedClientCode,
    clientCurrencies.join(","),
    selectedGameIdsKey,
  ].join("|");
  $: if (betScalesRequestKey !== requestedGameIdsKey) {
    requestedGameIdsKey = betScalesRequestKey;
    getBetScales(
      selectedClientCode && clientCurrencies.length && selectedGameIdsKey
        ? selectedGameIdsKey.split(",")
        : [],
    );
  }
  $: selectedClient = clients.find(
    (item) => String(item.id) === String(selectedClientId),
  );
  $: demoPlayers = getPragmaticDemoPlayers(
    selectedClient ?? selectedClientCode,
    selectedClientId,
    pragmaticCreateFRB.currency,
  );
  $: playerCatalogKey = `${selectedClientCode}|${clientCurrencies.join(",")}`;
  $: campaignCurrencyOptions = clientCurrencies.map((currency) => ({
    value: currency,
    description: currency,
  }));

  //validar que se ingresen solo números en rounds
  function validateNumberInput(event) {
    const inputValue = event.target.value;
    pragmaticCreateFRB.rounds = inputValue.replace(/\D/g, "");
  }

  function generateBonusCode() {
    if (!selectedClientCode) {
      alertify.alert("Selecciona un cliente", "Debes seleccionar un cliente antes de generar el código.");
      return;
    }
    pragmaticCreateFRB = {
      ...pragmaticCreateFRB,
      bonusCode: generatePragmaticBonusCode(selectedClientCode),
    };
  }

  const createSpin = async () => {
    if (!selectedClientCode) {
      alertify.alert("Complete los campos requeridos", "Selecciona un cliente.");
      return;
    }
    if (!String(pragmaticCreateFRB.bonusCode ?? "").trim()) {
      pragmaticCreateFRB = {
        ...pragmaticCreateFRB,
        bonusCode: generatePragmaticBonusCode(selectedClientCode),
      };
    }
    const fieldErrors = validatePragmaticFreeSpinFields({ ...pragmaticCreateFRB, startDate: campaignStartDate });
    if (fieldErrors.includes("bonusCode") || fieldErrors.includes("startDate") || fieldErrors.includes("assignationMode")) {
      alertify.alert("Complete los campos requeridos", "Hay campos requeridos que no están completos.");
      return;
    }
    if (fieldErrors.includes("bonusCodeFormat")) {
      alertify.alert("Configuración inválida", "El código del bonus solo puede contener letras y números.");
      return;
    }
    if (fieldErrors.includes("roundsInvalid")) {
      alertify.alert("Configuración inválida", "Rounds debe ser mayor que cero.");
      return;
    }
    if (fieldErrors.includes("roundsAndFrType")) {
      alertify.alert("Configuración invalida", "Se han seleccionado campos que no son combinables");
      return;
    }
    if (fieldErrors.includes("awardConfiguration")) {
      alertify.alert("Configuración inválida", "Debes indicar Rounds o seleccionar un tipo de FreeSpin.");
      return;
    }
    const campaignCurrency = normalizeCurrency(pragmaticCreateFRB.currency);
    if (!campaignCurrency || !clientCurrencies.includes(campaignCurrency)) {
      alertify.alert(
        "Complete los campos requeridos",
        "Selecciona una moneda válida para la campaña.",
      );
      return;
    }

    const startDate = parseLimaDateTime(campaignStartDate);
    const expirationDate = pragmaticCreateFRB.expirationDate
      ? parseLimaDateTime(pragmaticCreateFRB.expirationDate)
      : null;
    if (!startDate || Number.isNaN(startDate.getTime())) {
      alertify.alert("Configuración inválida", "Selecciona una fecha y hora de inicio válida.");
      return;
    }
    if (!expirationDate || Number.isNaN(expirationDate.getTime())) {
      alertify.alert("Configuración inválida", "Completa la fecha y hora de expiración.");
      return;
    }
    if (expirationDate <= startDate) {
      alertify.alert("Configuración inválida", "La expiración debe ser posterior al inicio.");
      return;
    }
    if (expirationDate.getTime() - startDate.getTime() > 30 * 86400000) {
      alertify.alert("Configuración inválida", "La expiración puede estar como máximo a 30 días del inicio.");
      return;
    }
    if (gameConfigurations.length === 0) {
      alertify.alert('Complete los campos! ', 'No se han selecionado juegos!');
      return;
    }
    if (incompatibleSelectedGames.length > 0) {
      alertify.alert(
        "Juegos incompatibles",
        "Retira los juegos que no admiten el tipo de FreeSpin seleccionado antes de crear la campaña.",
      );
      return;
    }
    if (pragmaticCreateFRB.frType === "F" && selectedGame.length > 1) {
      alertify.alert(
        "Demasiados juegos",
        "Full Scatter permite seleccionar un solo juego. Retira los demás antes de crear la campaña.",
      );
      return;
    }
    const gameErrors = validateGameConfigurations(gameConfigurations, clientCurrencies);
    if (gameErrors.length > 0) {
      alertify.alert('Configuración invalida', gameErrors.join('<br>'));
      return;
    }
    const games = buildGamesPayload(gameConfigurations);
    const payloadErrors = validateGamesPayload(games, clientCurrencies);
    if (payloadErrors.length > 0) {
      alertify.alert('Solicitud invalida', payloadErrors.join('<br>'));
      return;
    }
    const clientCode = selectedClientCode;
    let request;
    try {
      request = buildPragmaticFreeSpinRequest({
        form: pragmaticCreateFRB,
        games,
        players,
        selectedPlayerId,
        clientCode,
        startDate: startDate.toISOString(),
        expirationDate: expirationDate?.toISOString(),
        validityDate: expirationDate?.toISOString(),
      });
    } catch (error) {
      alertify.alert('Configuración invalida', error.message);
      return;
    }
    const createAction = request.route === "player"
      ? backend.freespin.createFreeSpinPlayerPP
      : backend.freespin.createFreeSpinPrg;

    try {
      const response = await createAction(request.payload);
      alertify.success("Campaña Free Spins creada exitosamente");
      dispatch("freespinCreated", response?.data);
      showNewFreeSpin = false;

      return response;
    } catch (error) {
      console.error("Error creando campaña:", error);
      alertify.alert(
        "Creación de bonus fallida",
        "No se pudo crear el Free Spin. Vuelve a intentarlo."
      );
      return;
    }

  };

  const hasSelectedClient = () => {
    const clientId = configBonnus?.client?.id;

    return clientId !== null &&
      clientId !== undefined &&
      clientId !== "";
  };
  
</script>


<Modal
  isOpen={showNewFreeSpin}
  toggle={onShowModalFreeSpin}
  size="xl"
  centered={true}
  modalClassName="pragmatic-create-modal"
>
  <ModalHeader toggle={onShowModalFreeSpin}>
    Crear campaña Pragmatic Free Spin
  </ModalHeader>
  <ModalBody>
    <div class="freeSpin-modal">
      <section class="form-group compact-fields" aria-labelledby="main-configuration-title">
        <h6 id="main-configuration-title" class="section-title">General</h6>
        <div class="section-box list-inputs general-fields">
          <div>
            Cliente <span class="required-marker" aria-hidden="true">*</span>
            <div class="search-section">
              <Dropdown
                options={clients}
                multiple={false}
                bind:value={selectedClientId}
                placeholder="Seleccionar cliente..."
                valueKey="id"
                labelKey="namesite"
                isStructuredDescription={true}
                paramStructuredName={['code','namesite']}
              >
              </Dropdown>
            </div>
          </div>

          <div>
            <span class="field-label">
              Método de asignación: <span class="required-marker" aria-hidden="true">*</span>
              <InfoTooltip
                info={[
                  "Automática: el bonus se asignará automáticamente al momento de que el jugador abra el juego.",
                  "Manual: el bonus se asignará manualmente desde el gestor de Bonos",
                ]}
                ariaLabel="Información sobre los modos de asignación"
              />
            </span>
            <div class="search-section">
              <Dropdown
                options={ASSIGNATION_MODE}
                bind:value={pragmaticCreateFRB.assignationMode}
                placeholder="Seleccionar modo de asignación..."
                valueKey="value"
                labelKey="label"
              >
              </Dropdown>
            </div>
          </div>
        </div>
      </section>

      <section class="form-group compact-fields" aria-labelledby="campaign-details-title">
        <h6 id="campaign-details-title" class="section-title">Detalles de campaña</h6>
        <div class="section-box list-inputs campaign-fields">
          <div>
            Código del bonus:
            <span>
              <InfoTooltip
                info={["Opcional. Si no ingresas un código, al crear la campaña el sistema generará uno."]}
              />
            </span>
            <input
              class="form-control"
              bind:value={pragmaticCreateFRB.bonusCode}
              pattern="[A-Za-z0-9]+"
              title="Solo se permiten letras y números"
            />
            <button type="button" class="generate-code-action" on:click={generateBonusCode}>
              Generar código
            </button>
          </div>

          <label>
            Fecha y hora de inicio: <span class="required-marker" aria-hidden="true">*</span>
            <input class="form-control" type="datetime-local" step="60" bind:value={campaignStartDate} required />
            <small class="field-help">
              Usar como referencia la fecha y hora actual del cliente, tienda u ORG objetivo.
            </small>
          </label>

          <label>
            <span class="validity-field-label">
              Fecha y hora de expiración: <span class="required-marker" aria-hidden="true">*</span>
            </span>
            <input class="form-control" type="datetime-local" step="60" bind:value={pragmaticCreateFRB.expirationDate} required />
          </label>

          {#if !pragmaticCreateFRB.frType}
            <label>
              Rounds:
              <input
                class="form-control"
                inputmode="numeric"
                pattern="[1-9][0-9]*"
                bind:value={pragmaticCreateFRB.rounds}
                on:input={validateNumberInput}
              />
            </label>
          {/if}

          {#if !pragmaticCreateFRB.rounds}
            <div>
              <span class="free-spin-type-label">
                Tipo de FreeSpin:
                <InfoTooltip
                info={["FULL SCATTER: Rondas instantaneas asignadas de acuerdo a la cantidad predefinida de cada juego"]}
                ariaLabel="Información sobre los tipos de FreeSpin"
                />
              </span>
              <Dropdown
                  options={FRB_TYPES}
                  multiple={false}
                  value={pragmaticCreateFRB.frType}
                  placeholder="Seleccionar..."
                  valueKey="value"
                  labelKey="description"
                  on:change={(event) => setFreeSpinType(event.detail)}
                ></Dropdown>
            </div>
          {/if}

          <div>
            Moneda: <span class="required-marker" aria-hidden="true">*</span>
            <div class="search-section">
              <Dropdown
                options={campaignCurrencyOptions}
                value={pragmaticCreateFRB.currency}
                placeholder={currenciesLoading ? "Cargando monedas..." : "Seleccionar moneda..."}
                disabled={true}
                on:change={(event) => setCampaignCurrency(event.detail)}
              />
            </div>
          </div>

          <div>
            Jugador:
            <div class="search-section">
              {#key playerCatalogKey}
                <RemotePlayerSelect
                  clientId={selectedClientId}
                  bind:value={selectedPlayerId}
                  bind:players
                  placeholder={currenciesLoading ? "Cargando monedas..." : "Seleccionar jugador..."}
                  staticPlayers={demoPlayers}
                  listPlayers={listPragmaticPlayers}
                  disabled={!selectedClientId || currenciesLoading || !clientCurrencies.length}
                />
              {/key}
            </div>
            {#if currenciesError}
              <small class="currency-error">{currenciesError}</small>
            {/if}
          </div>
        </div>
      </section>

      <section class="form-group" aria-labelledby="games-configuration-title">
        <h6 id="games-configuration-title" class="section-title">Detalles de juegos</h6>
        <div class="section-box">
          <div class="games-controls">
          <div>
            Juegos: <span class="required-marker" aria-hidden="true">*</span>
            <div class="search-section">
              {#if pragmaticCreateFRB.frType === "F"}
                <Dropdown
                  options={filteredGamesList}
                  multiple={false}
                  value={selectedGame[0] ?? ""}
                  placeholder={gamesLoading ? "Cargando juegos..." : "Seleccionar un juego..."}
                  valueKey='gameID'
                  labelKey='gameName'
                  disabled={!selectedClientId || currenciesLoading || gamesLoading || !clientCurrencies.length}
                  on:change={(event) => setSingleGame(event.detail)}
                ></Dropdown>
              {:else}
                <Dropdown
                  options={filteredGamesList}
                  multiple={true}
                  bind:value={selectedGame}
                  placeholder={gamesLoading ? "Cargando juegos..." : "Seleccionar juego..."}
                  valueKey='gameID'
                  labelKey='gameName'
                  disabled={!selectedClientId || currenciesLoading || gamesLoading || !clientCurrencies.length}
                ></Dropdown>
              {/if}
            </div>
            {#if gamesError}
              <small class="currency-error">{gamesError}</small>
            {/if}
            {#if pragmaticCreateFRB.frType === "F" && incompatibleSelectedGames.length === 0}
              <small class="games-feature-info">
                Solo se muestran juegos compatibles con Full Scatter.
              </small>
            {/if}
          </div>

          <div>
            Tipo de apuesta para toda la campaña:
            <div class="search-section">
              <Dropdown
                options={CAMPAIGN_BET_TYPE_OPTIONS}
                value={campaignBetType}
                clearable={false}
                placeholder="Seleccionar tipo de apuesta..."
                on:change={(event) => updateCampaignBetType(event.detail)}
              />
            </div>
          </div>
          </div>

          {#if incompatibleSelectedGames.length > 0}
            <div class="games-feature-warning" role="alert">
              <div>
                <strong>Hay juegos incompatibles con Full Scatter:</strong>
                {incompatibleSelectedGames.map((game) => game.gameName ?? game.gameID).join(", ")}.
              </div>
              <button type="button" class="remove-incompatible-action" on:click={removeIncompatibleGames}>
                Retirar juegos incompatibles
              </button>
            </div>
          {/if}

          {#if gameConfigurations.length > 0}
            <div class="game-configurations table-responsive">
            <table class="table table-bordered table-sm game-configurations-table">
              <thead>
                <tr>
                  <th>Juego</th>
                  <th>Líneas</th>
                  <th>Tipo de configuración</th>
                  <th>Valor</th>
                </tr>
              </thead>
              <tbody>
                {#each gameConfigurations as game (game.gameId)}
                  {#each game.betValues as betValue, rowIndex}
                    <tr>
                      {#if rowIndex === 0}
                        <td class="game-name-column" rowspan={game.betValues.length}>{game.gameName}</td>
                        <td class="lines-column" rowspan={game.betValues.length}>{game.lines ?? "—"}</td>
                      {/if}
                      <td class="bet-type-column">
                        {betValue.betType === "betPerLine" ? "Por línea" : "Apuesta total"}
                      </td>
                      <td class="bet-value-column">
                        <div class="configuration-dropdown bet-value-input">
                          <Dropdown
                            options={betScaleDropdownOptions(game.gameId, betValue)}
                            value={betValue.value}
                            placeholder={betScalePlaceholder(game.gameId, betValue)}
                            disabled={betScalesLoading || betScaleOptions(game.gameId, betValue).length === 0}
                            on:change={(event) => updateBetValue(game.gameId, rowIndex, "value", event.detail)}
                          />
                        </div>
                      </td>
                    </tr>
                  {/each}
                {/each}
              </tbody>
            </table>
            </div>
          {/if}
        </div>
      </section>
    </div>
</ModalBody>
<ModalFooter>
  <button
    type="button"
    class="btn btn-secondary"
    on:click={onShowModalFreeSpin}
  >Cancelar</button>
  <button
    type="button"
    class="btn btn-success"
    disabled={currenciesLoading || gamesLoading || !clientCurrencies.length || incompatibleSelectedGames.length > 0}
    on:click={createSpin}
  >Crear Free Spin</button>
</ModalFooter>
</Modal>

<style>
  .required-marker { color: #dc3545; }
  .field-label { display: inline-flex; align-items: center; }
  .field-help { display: block; margin-top: 0.3rem; color: #0b5ed7; font-size: 0.75rem; font-weight: 600; line-height: 1.25; }
  .generate-code-action { display: block; margin-top: 0.3rem; padding: 0; border: 0; background: transparent; color: #0b5ed7; font-size: 0.75rem; font-weight: 600; line-height: 1.25; text-align: left; cursor: pointer; }
  .generate-code-action:hover { color: #084298; text-decoration: underline; }
  .currency-error { display: block; margin-top: -0.35rem; color: #dc3545; }
  .games-feature-info { display: block; margin-top: 0.3rem; color: #0b5ed7; }
  .games-feature-warning {
    display: flex;
    flex-wrap: wrap;
    align-items: center;
    justify-content: space-between;
    gap: 1rem;
    margin-top: 0.75rem;
    padding: 0.65rem 0.75rem;
    border: 1px solid #ffda6a;
    border-radius: 0.5rem;
    background: #fff3cd;
    color: #664d03;
    font-size: 0.825rem;
  }
  .remove-incompatible-action {
    flex: 0 0 auto;
    padding: 0;
    border: 0;
    background: transparent;
    color: #084298;
    font-weight: 600;
    text-decoration: underline;
    cursor: pointer;
  }
  .free-spin-type-label { display: inline-flex; align-items: center; gap: 0.35rem; }
  .freeSpin-modal{
      display: flex;
      flex-direction: column;
      gap: 0.75rem;
  }
  .freeSpin-modal .form-group { margin-bottom: 0; }
  :global(.pragmatic-create-modal .modal-dialog) {
    width: calc(100% - 2rem);
    max-width: 1140px;
  }
  :global(.pragmatic-create-modal .modal-body) { padding: 0.85rem; }
  .section-box {
    padding: 0.65rem 0.75rem;
    border: 1px solid #e2e6ea;
    border-radius: 0.75rem;
    background: #fff;
    box-shadow: none;
  }
  .section-title {
    margin: 0 0 0.5rem;
    color: #344054;
    font-size: 0.95rem;
    font-weight: 650;
  }
  .list-inputs {
    display: grid;
    grid-template-columns: repeat(2, minmax(0, 1fr));
    gap: 1rem;
    width: 100%;
    max-width: 100%;
  }
  .general-fields { grid-template-columns: repeat(2, minmax(0, 1fr)); }
  .campaign-fields { grid-template-columns: repeat(3, minmax(0, 1fr)); }
  .validity-field-label { display: inline-flex; align-items: center; gap: 0.3rem; }
  .games-controls {
    display: grid;
    grid-template-columns: minmax(0, 2fr) minmax(15rem, 1fr);
    gap: 1rem;
    align-items: start;
  }
  .compact-fields .form-control {
    min-height: 34px;
    padding: 0.3rem 0.55rem;
    font-size: 0.825rem;
  }
  .compact-fields .form-control:focus { box-shadow: none; }
  .compact-fields :global(.select-box) {
    --dropdown-height: 34px;
    --dropdown-font-size: 0.825rem;
  }
  .section-box :global(.trigger:focus),
  .section-box :global(.trigger[aria-expanded="true"]),
  .section-box :global(.dropdown) { box-shadow: none; }
  @media (max-width: 900px) {
    .list-inputs,
    .general-fields,
    .campaign-fields { grid-template-columns: repeat(2, minmax(0, 1fr)); }
    .games-controls { grid-template-columns: minmax(0, 1fr); }
  }
  @media (max-width: 600px) {
    :global(.pragmatic-create-modal .modal-dialog) { width: calc(100% - 1rem); }
    .section-box { padding: 0.65rem; }
    .list-inputs,
    .general-fields,
    .campaign-fields { grid-template-columns: minmax(0, 1fr); }
  }

  .search-section {
    display: flex;
    justify-content: space-between;
    margin-bottom: 10px;
  }

  .game-configurations { margin-top: 1rem; }
  .game-configurations.table-responsive { overflow: visible; }
  @media (max-width: 900px) {
    .game-configurations.table-responsive {
      overflow: auto;
      -webkit-overflow-scrolling: touch;
    }
  }
  .game-configurations-table th { padding: 0.65rem 0.5rem; background: #f8fafc; text-align: center; vertical-align: middle; }
  .game-configurations-table td { padding: 0.25rem; vertical-align: middle; }
  .game-configurations-table tbody tr:hover { background: #fbfcfe; }
  .game-name-column { width: 11rem; text-align: left; overflow-wrap: anywhere; }
  .lines-column { width: 6rem; text-align: center; }
  .bet-type-column { width: 9rem; }
  .bet-value-column { width: 11rem; text-align: center; }
  .bet-value-input { width: 100%; margin: 0; }
  :global(.configuration-dropdown .trigger) { height: 2.5rem; padding: 0.375rem 2.75rem 0.375rem 0.75rem; border: 0; border-radius: 0.25rem; background: transparent; box-shadow: none; font-size: 0.9375rem; line-height: 1.5; }
  :global(.configuration-dropdown .trigger:hover) { background: #f3f6f9; }
  :global(.configuration-dropdown .trigger:focus) { background: #fff; box-shadow: inset 0 0 0 2px #80bdff; outline: 0; }
  :global(.configuration-dropdown .trigger.placeholder) { padding-right: 1.75rem; }
  :global(.configuration-dropdown .dropdown) { min-width: 8rem; }
</style>
